export enum USER_ROLES {
  ACCOUNTING = 'ACCOUNTING',
  ADMIN = 'ADMIN',
  ADMINISTRATIVE = 'ADMINISTRATIVE',
  ANIMATION = 'ANIMATION',
  CAMPUS_TESTER = 'CAMPUS_TESTER',
  COACH = 'COACH',
  CONCEPTION = 'CONCEPTION',
  CORRECTOR = 'CORRECTOR',
  EDITOR = 'EDITOR',
  EXTERNAL_EDITOR = 'EXTERNAL_EDITOR',
  INTERNSHIPS = 'INTERNSHIPS',
  SALES = 'SALES',
  SUPER_ADMIN = 'SUPER_ADMIN',
  SUPPORT = 'SUPPORT',
  TEACHER = 'TEACHER',
}

export enum USER_ACCOUNT_TYPES {
  STUDENT = 'STUDENT',
  EMPLOYEE = 'EMPLOYEE',
  TUTOR = 'TUTOR',
}

export enum USER_VIEWS {
  MIN = 'MIN',
  FULL = 'FULL',
  EXTERNAL = 'EXTERNAL',
  PERSONAL = 'PERSONAL',
  PUBLIC = 'PUBLIC',
}

export enum USER_COURSE_ACCESS_TYPES {
  FULL = 'FULL',
  LIMITED = 'LIMITED',
  PENDING = 'PENDING',
}

// Make sure to keep these sanitized, they are used in email addresses.
export const ACCOUNT_EMAIL_DOMAIN = 'enaco.fr';
export const STUDENT_ACCOUNT_EMAIL_SUFFIX = '-students';
export const INTERNAL_ACCOUNT_EMAIL_SUFFIX = '';

/** Prefix of the Shopify global id carried as a student reference by e-commerce accounts. */
export const SHOPIFY_CUSTOMER_GID_PREFIX = 'gid://shopify/Customer/';

// Maximum number of profile pictures to keep.
export const USER_PICTURES_HISTORY_LENGTH = 4;

export const USER_CALENDAR_EVENTS_DEFAULT_LIMIT = 100;

export const USER_APPOINTMENTS_DEFAULT_LIMIT = 100;

export enum PING_STATES {
  // Start / continue.
  ACTIVE = 'ACTIVE',
  // Stop.
  INACTIVE = 'INACTIVE',
}

// Maximum time between 2 consecutive pings to consider that this is still the same session.
// In seconds.
export const MAX_ACTIVITY_PING_DELAY = 5 * 60;

export enum USER_COURSE_KPIS_TYPES {
  PROGRESS = 'PROGRESS',
  TIME_SPENT = 'TIME_SPENT',
  OVERALL_AVERAGE = 'OVERALL_AVERAGE',
  OVERALL_AVERAGE_PENALIZED = 'OVERALL_AVERAGE_PENALIZED',
}

export enum STUDENT_PLANS {
  INITIAL = 'INITIAL',
  MPE = 'MPE',
  TP_HDF = 'TP_HDF',
  APPRENTISSAGE = 'APPRENTISSAGE',
  APPRENTI_SANS_ENTREPRISE = 'APPRENTI_SANS_ENTREPRISE',
  CONTRAT_PROFESSIONNALISATION = 'CONTRAT_PROFESSIONNALISATION',
  PERIODE_PROFESSIONNALISATION = 'PERIODE_PROFESSIONNALISATION',
  CPF = 'CPF',
  PLAN_FORMATION = 'PLAN_FORMATION',
  PLAN_SAUVEGARDE_EMPLOI = 'PLAN_SAUVEGARDE_EMPLOI',
  CONVENTION_RECLASSEMENT_PERSONNALISE = 'CONVENTION_RECLASSEMENT_PERSONNALISE',
  CIF = 'CIF',
  CONTRAT_SECURISATION_PROFESSIONNEL = 'CONTRAT_SECURISATION_PROFESSIONNEL',
  CONGE_FORMATION_PROFESSIONNEL = 'CONGE_FORMATION_PROFESSIONNEL',
  PLAN_LICENCIEMENT = 'PLAN_LICENCIEMENT',
  CONTRAT_TRANSITION_PROFESSIONNELLE = 'CONTRAT_TRANSITION_PROFESSIONNELLE',
  CONGE_RECLASSEMENT = 'CONGE_RECLASSEMENT',
  AIF = 'AIF',
  MISSION_LOCALE = 'MISSION_LOCALE',
  REGION = 'REGION',
  FINANCEMENT_ENTREPRISE = 'FINANCEMENT_ENTREPRISE',
  PLAN_DEPART_VOLONTAIRE = 'PLAN_DEPART_VOLONTAIRE',
  BOOST = 'BOOST',
  SUBSCRIPTION = 'SUBSCRIPTION',
}

export const STUDENTS_PLANS_NOT_ELIGIBLE_TO_EXAM_REGISTRATION = [
  STUDENT_PLANS.APPRENTI_SANS_ENTREPRISE,
  STUDENT_PLANS.BOOST,
];

export enum STUDENT_CARD_TYPES {
  ENACO = 'enaco',
  METIER = 'metier',
  NONE = 'none',
}

export const AVAILABLE_STUDENT_CARD_TYPES = [STUDENT_CARD_TYPES.ENACO, STUDENT_CARD_TYPES.METIER];

export enum STREAK_DAY_TYPES {
  WEEK_END = 'WEEK_END',
  CURRENT_DAY = 'CURRENT_DAY',
  CONNECTED = 'CONNECTED',
  NOT_CONNECTED = 'NOT_CONNECTED',
}

export const NB_DAYS_BEFORE_INACTIVITY = 28;

export const GOOGLE_CALENDAR_URL = 'https://calendar.google.com/calendar';

export const GOOGLE_MAIL_URL = 'https://mail.google.com/mail/u/';

export enum FEATURE_FLAGS {
  CAMPUS_STUDENT_CLASSMATES = 'campus_student_classmates',
  DISABLE_ESTIMATED_READING_TIME = 'disable_estimated_reading_time',
  DISPLAY_BACKOFFICE_STUDENTS_EXTRACT = 'display_backoffice_students_extract',
  DISPLAY_CAMPUS_BANNER_HOME = 'display_campus_banner_home',
  DISPLAY_DISCORD_BUTTON = 'display_discord_button',
  DISPLAY_TEACHER_STATISTICS = 'display_teacher_statistics',
  DISPLAY_PRIDE_MONTH_LOGO = 'display_pride_month_logo',
  DISPLAY_SEQUENCE_ACTIVITY = 'display_sequence_activity',
  ENABLE_BLOCKING_DELAYED_PAYMENT = 'enable_blocking_delayed_payment',
  ENABLE_CALENDLY_MEETINGS = 'enable_calendly_meetings',
  ENABLE_ONBOARDING_MEETING = 'enable_onboarding_meeting',
  ENABLE_SENDING_EMAIL_WITH_BREVO = 'enable_sending_email_with_brevo',
  ONBOARDING_MEETING_OPTIONAL = 'onboarding_meeting_optional',
  SEND_VISITED_PAGES_EVENTS_TO_MIXPANEL = 'send_visited_pages_events_to_mixpanel',
  DISPLAY_PAST_VC_TAB = 'display_past_vc_tab',
  ENABLE_LANGUAGE_INTERNATIONALIZATION = 'enable_language_internationalization',
  DISPLAY_BACK_OFFICE_NOTIFICATIONS = 'display_back_office_notifications',
  ENABLE_THEME_MODE = 'enable_theme_mode',
  ENABLE_ASSIGNMENT_MIA_PRE_SUBMISSION_REVIEW = 'enable_assignment_mia_pre_submission_review',
  ENABLE_AI_SEARCH_BAR_HP_CAMPUS = 'enable_ai_search_bar_hp_campus',
  ENABLE_CAMPUS_SEARCH_BAR = 'enable_campus_search_bar',
}

export const CAMPUS_SEARCH_MIN_QUERY_LENGTH = 2;

export enum CAMPUS_SEARCH_HIT_TYPES {
  ASSIGNMENT = 'assignment',
  CLASSMATE = 'classmate',
  CMS_PAGE = 'cmsPage',
  COURSE = 'course',
  DOCUMENT = 'document',
  FLASHCARDS_DECK = 'flashcardsDeck',
  HELP_ARTICLE = 'helpArticle',
  LEARNING_RESOURCE = 'learningResource',
  LESSON = 'lesson',
  NEWS = 'news',
  PAGE = 'page',
  TEACHER = 'teacher',
  VIRTUAL_CLASSROOM = 'virtualClassroom',
}

export enum ENVIRONMENT_FLAGS {
  DISPLAY_CAMPUS_BANNER_LOGIN = 'display_campus_banner_login',
  LOGIN_WITH_ANIMATION = 'login_with_animation',
}

export enum PACK_TYPES {
  ISTART = 'ISTART',
  IAVANTAGES = 'IAVANTAGES',
  IAEXCELLENCE = 'IAEXCELLENCE',
}

export enum DOCUMENT_TYPES {
  ACADEMIC_TRANSCRIPT = 'ACADEMIC_TRANSCRIPT',
  SCHOOL_CERTIFICATE = 'SCHOOL_CERTIFICATE',
  STUDENT_CARD = 'STUDENT_CARD',
  SUBMISSIONS_ARCHIVE = 'ASSIGNMENTS_AND_CORRECTIONS_ARCHIVE',
}

export const DISPLAY_NAME_MAX_LENGTH = 30;

export const RECENTLY_CONNECTED_THRESHOLD_MINUTES = 15;

export * from './appointment-scheduling';
export * from './contact-categories';
export * from './error-codes';
export * from './internships';
export * from './model';
export * from './product-tours';
